module.exports = __webpack_public_path__ + "static/themes-matchingaccents-do-7ba69da92352f4bb8aa37442f36c49f5.png";